import InboxRule from 'owa-service/lib/contract/InboxRule';
import InboxRuleInformation from './store/schema/InboxRuleInformation';
import mapInboxRuleToInboxRuleInformation from './utils/mapInboxRuleToInboxRuleInformation';
import InboxRuleActionSource from './store/schema/InboxRuleActionSource';
import InboxRuleRowType from './store/schema/InboxRuleRowType';

export default {
    enableDisableInboxRuleDatapoint: {
        datapoint: {
            name: 'TnS_EnableDisableInboxRule',
            customData: (
                inboxRuleId: string,
                shouldBeEnabled: boolean,
                force: boolean,
                alwaysDeleteOutlookRulesBlob: boolean
            ) => [inboxRuleId, shouldBeEnabled, force, alwaysDeleteOutlookRulesBlob],
        },
    },
    generateInboxRulesDiagnosticReportDatapoint: {
        datapoint: { name: 'TnS_GenerateInboxRulesDiagnosticReport' },
    },
    getInboxRulesDatapoint: { datapoint: { name: 'TnS_GetInboxRules' } },
    // logs information about each individual rule from the getInboxRules response
    getInboxRuleDatapoint: {
        datapoint: {
            name: 'TnS_GetInboxRule',
            customData: (inboxRule: InboxRule) => {
                return mapInboxRuleToInboxRuleInformation(inboxRule) as {
                    [key in keyof InboxRuleInformation]: string | number | boolean
                };
            },
        },
    },
    editInboxRuleDatapoint: {
        datapoint: {
            name: 'TnS_EditInboxRule',
            customData: (inboxRule: InboxRule) => {
                return mapInboxRuleToInboxRuleInformation(inboxRule) as {
                    [key in keyof InboxRuleInformation]: string | number | boolean
                };
            },
        },
    },
    createNewInboxRuleDatapoint: {
        datapoint: {
            name: 'TnS_NewInboxRule',
            customData: (
                inboxRule: InboxRule,
                actionSource: InboxRuleActionSource,
                onSuccess: () => {},
                onFailure: () => {}
            ) => {
                const result = mapInboxRuleToInboxRuleInformation(inboxRule);
                result.ActionSource = actionSource;
                return result;
            },
        },
    },
    setInboxRuleDatapoint: {
        datapoint: {
            name: 'TnS_SetInboxRule',
            customData: (
                inboxRule: InboxRule,
                force: boolean,
                alwaysDeleteOutlookRulesBlob: boolean
            ) => {
                const result = mapInboxRuleToInboxRuleInformation(inboxRule);
                result.Force = force;
                result.AlwaysDeleteOutlookRulesBlob = alwaysDeleteOutlookRulesBlob;
                return result;
            },
        },
    },
    numInboxRules: {
        datapoint: {
            name: 'TnS_NumInboxRules',
            customData: (inboxRuleCollectionLength: number) => [inboxRuleCollectionLength],
        },
    },
    removeInboxRuleDatapoint: {
        datapoint: {
            name: 'TnS_RemoveInboxRule',
            customData: (
                inboxRule: InboxRuleRowType,
                force: boolean,
                alwaysDeleteOutlookRulesBlob: boolean
            ) => {
                const result = mapInboxRuleToInboxRuleInformation(inboxRule);
                result.Force = force;
                result.AlwaysDeleteOutlookRulesBlob = alwaysDeleteOutlookRulesBlob;
                return result;
            },
        },
    },
    setInboxRulesDatapoint: { datapoint: { name: 'TnS_SetInboxRules' } },
    inboxRuleInformationDatapoint: {
        datapoint: {
            name: 'TnS_InboxRuleInformation',
            customData: (inboxRuleInformation: InboxRuleInformation) => {
                return inboxRuleInformation;
            },
        },
    },
    addPhraseToClauseDatapoint: {
        datapoint: {
            name: 'TnS_AddPhraseToClause',
            customData: (
                clauseId: string,
                phraseToAdd: string,
                actionSource: InboxRuleActionSource
            ) => [phraseToAdd.indexOf(' ') !== -1, actionSource],
        },
    },
    inboxRuleActionFailDatapoint: {
        datapoint: {
            name: 'TnS_InboxRuleActionFail',
            customData: (inboxRuleInformation: InboxRuleInformation) => {
                return inboxRuleInformation;
            },
        },
    },
};
